export default {
  methods: {
    rupeeFormat: function (text, options) {
      let value = text ? text.toString().replace(/,/g, "") : "";
      let val = Math.round(value).toString();

      let lastThree = val.substring(val.length - 3);
      let otherNumbers = val.substring(0, val.length - 3);
      if (otherNumbers != "") lastThree = "," + lastThree;
      const formatText = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
      if (options?.symbol) {
        return (options?.symbol || "") + formatText;
      }
      return formatText;
    }
  }
};
